import React, { useEffect, useState } from "react";
import { Box, useMediaQuery, CircularProgress, Button } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Grid from "@mui/material/Grid2";
import theme from "../../theme";
import { useDispatch } from "react-redux";
import TitleBar from "../common-components/TitleBar";
import { StyledGrid } from "../../pages/incorporation/Incorporation";
import { UploadIcon } from "../../assets/Icon/dashboredIcon";
import SelectInputField from "../common-components/SelectInputField";
import { company_type } from "../common-components/SelectData";
import { useFormik } from "formik";
import UploadMultipleFile from "../common-components/UploadMultipleFile";
import UploadFileFieldNew from "../common-components/UploadFileFieldNew";
import * as Yup from "yup";
import ApiHelperFunction from "../../api";
import { setToast } from "../../stores/toast/toastslice";
import { useNavigate, useParams } from "react-router-dom";
import {
  getOperatingAgreementDetail,
  getOperatingAgreementList,
} from "../../stores/clients";
import ListLoadingNew from "../common-components/ListLoadingNew";
import PreviewModal from "../itin/PreviewModal";
import { Document, Page, pdfjs } from "react-pdf";
import PdfPreviewModal from "../common-components/PdfPreviewModal";
// worker config
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const OAStepTwo = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const [oaDetail, setOaDetail] = useState<any>();
  const [filePreview, setFilePreview] = useState<string | null>("");
  const [isList, setIsList] = useState<any>();
  const [pageLoader, setPageLoader] = useState(true);
  const [filePreviews, setFilePreviews] = useState<string[]>([]);
  const token = localStorage.getItem("user_token");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [fileUrl, setFileUrl] = useState<any>();
  const [pdfUrl, setPdfUrl] = useState<any>();
  const navigate = useNavigate();

  const [pdfOpen, setPdfOpen] = useState(false);

  const { id } = useParams();

  const handleClose = () => setOpenPreview(false);

  const fetchList = async () => {
    await dispatch<any>(getOperatingAgreementList({ page: 1, limit: 10 })).then(
      (res: any) => {
        console.log(res?.payload);
        setIsList(res?.payload?.data?.agreements);
        if (res?.payload?.data?.agreements?.length === 0) {
          navigate("/tools/operating-agreement");
        }
      },
    );
  };

  const fetchDetails = async () => {
    setLoading(true);
    await dispatch<any>(
      getOperatingAgreementDetail({ order_id: Number(id) ?? 0 }),
    ).then(async (res: any) => {
      if (res?.payload?.status >= 400) {
        await dispatch<any>(
          setToast({
            message:
              res?.payload?.data?.message ||
              (typeof res?.payload?.data?.message === "string" &&
                res?.payload?.data?.message) ||
              "Something went wrong!",
            type: "error",
            title: "Error",
          }),
        );
        const timeout = setTimeout(() => {
          navigate("/tools/operating-agreement");
        }, 2000);

        return () => clearTimeout(timeout);
      }
      setLoading(false);
      setPageLoader(false);
      setOaDetail(res?.payload?.data);
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPageLoader(false);
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (id) {
      fetchDetails();
    }
    fetchList();
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    const companyType: string =
      company_type.find((item: any) => item.name === formik.values.company_type)
        ?.value || "";
    formData.append("company_type", companyType);
    formData.append("passport", formik.values.passport);
    formik.values.operating_agreement_files.forEach((file: any) => {
      formData.append("operating_agreement_files", file);
    });
    try {
      setLoading(true);
      const response = await ApiHelperFunction({
        url: "/upload-operating-agreement-documents",
        method: "POST",
        data: formData,
        headers: {
          Authorization: token ? `${token}` : "",
        },
      });
      console.log(response, "response");
      if (response?.data?.status === 1) {
        setLoading(false);
        dispatch<any>(
          setToast({
            message: response?.data?.message,
            type: "success",
            title: "Success",
          }),
        );
        navigate(
          `/tools/operating-agreement/${response?.data?.data?.order_item_id}`,
        );
        setOaDetail({
          ...response?.data?.data,
        });
      } else {
        setLoading(false);
        dispatch<any>(
          setToast({
            message: response?.data?.message || "Something went wrong!",
            type: "error",
            title: "Error",
          }),
        );
      }
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
      setLoading(false);
      dispatch<any>(
        setToast({
          message: error?.data?.message || "Something went wrong!",
          type: "error",
          title: "Error",
        }),
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChangeSingle = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0] || null;

    formik.setFieldValue("company_formation_file", file);

    if (file) {
      const previewURL = URL.createObjectURL(file);
      setFilePreview(previewURL);
    } else {
      setFilePreview("");
    }
  };
  const formik: any = useFormik({
    initialValues: {
      company_type: "",
      passport: null,
      operating_agreement_files: [],
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      company_type: Yup.string().required("Company Type is required"),
      passport: Yup.mixed().required("Passport is required"),
      operating_agreement_files: Yup.array().min(
        1,
        "At least one document is required",
      ),
    }),
    onSubmit: handleSubmit,
  });

  if (pageLoader) return <ListLoadingNew />;

  return (
    <Box sx={{ height: "calc(100vh - 120px)" }}>
      {isList?.length > 1 && (
        <Button
          sx={{
            mb: 0.5,
            color: "#6C6F71",
            display: "flex",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: 600,
            gap: 0.5,
            ml: -2,
          }}
          onClick={() => navigate("/tools/operating-agreement/list")}
        >
          <ArrowBackIosNewIcon /> Back
        </Button>
      )}
      <TitleBar title="Add the below details" description="" />

      <form onSubmit={formik.handleSubmit}>
        <StyledGrid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectInputField
              placeholder="Select Company Type"
              formik={formik}
              label="Company Type"
              menuData={company_type}
              disabled={false}
              name="company_type"
              sendValue
              // isCheckbox
            />
          </Grid>
        </StyledGrid>
        <StyledGrid container spacing={2}>
          <Grid size={{ xs: 12, lg: 6 }}>
            <UploadFileFieldNew
              title={"Passport Upload"}
              placeholder="Upload your passport"
              icon={<UploadIcon />}
              name="passport"
              formik={formik}
              handleFileChange={handleFileChangeSingle}
              setFilePreview={setFilePreview}
              setPdfUrl={setPdfUrl}
              setPdfOpen={setPdfOpen}
              setFileUrl={setFileUrl}
              isEyeIcon
              disabled={loading}
              filePreview={filePreview}
              setOpenPreview={setOpenPreview}
              accept="application/pdf, image/jpeg, image/png"
              showInstruction
            />
          </Grid>
          <Grid
            size={{ xs: 12, lg: 6 }}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0px 2px 40px 0px #dde3ea33",
              padding: "0px",
            }}
          >
            <UploadMultipleFile
              title={"Company Documents"}
              placeholder="Upload Documents"
              name="operating_agreement_files"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={filePreviews}
              setFilePreviews={setFilePreviews}
              setFileUrl={setPdfUrl}
              setOpenPreview={setPdfOpen}
              accept="application/pdf"
              isEyeIcon
              disabled={loading}
              showMoreButton={true}
              showInstruction={true}
              modeltitle="Document Instructions"
            />
          </Grid>
        </StyledGrid>

        {errorMessage && (
          <Box sx={{ color: "red", marginBottom: 2 }}>{errorMessage}</Box>
        )}

        <button
          type="submit"
          style={{
            margin: "auto",
            paddingTop: isMobile ? "12px" : "16px",
            paddingBottom: isMobile ? "12px" : "16px",
            paddingLeft: isMobile ? "24px" : "30px",
            paddingRight: isMobile ? "24px" : "30px",
            borderRadius: "8px",
            background: loading
              ? "#BDBDBD"
              : "linear-gradient(to right, #2977CC, #1D538F)",
            color: "white",
            border: "none",
            fontSize: isMobile ? "14px" : "16px",
            fontWeight: 600,
            marginTop: isMobile ? "16px" : "22px",
            cursor: "pointer",
            minWidth: isMobile ? "140px" : "auto",
            height: "52px",
            opacity: loading ? 0.7 : 1,
          }}
          disabled={loading}
        >
          {loading ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            </span>
          ) : (
            "Submit"
          )}
        </button>
      </form>
      <PdfPreviewModal
        open={pdfOpen}
        onClose={() => setPdfOpen(false)}
        fileUrl={pdfUrl}
      />

      <PreviewModal
        open={openPreview}
        handleClose={handleClose}
        img={fileUrl ?? ""}
      />
    </Box>
  );
};

export default OAStepTwo;
